<section class="resultados">
    
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <h4>{{ data.TITULO }}</h4>
            </div>
        </div>
        <ul>
            <li class="mb-3" *ngFor="let dado of data.DADOS"><i class="fa fa-angle-right fa-lg text-primary mr-2"></i>{{ dado.TEXTO }}</li>
        </ul>
    </div>

</section>